import React from 'react'
import styled from '@emotion/styled'
import { Select } from '@labsavvyapp/components'
import { useOrdersetSettingsPageBusinessLogic } from '../../../../../../logic/context'

const OrdersetListFiltersLayout = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 400px;
  align-items: center;
  align-content: center;
  gap: 10px;
  justify-content: flex-end;
`

export const OrdersetListFilters = () => {
  const pageLogic = useOrdersetSettingsPageBusinessLogic()
  const userSelectedLaboratoryId = pageLogic?.userSelectedLaboratoryId
  const laboratoryList = pageLogic?.laboratoryList ?? []

  return (
    <OrdersetListFiltersLayout>
      <span>Laboratory</span>
      <Select
        label=""
        description=""
        placeholder="Select Laboratory"
        data={laboratoryList}
        searchable={true}
        value={userSelectedLaboratoryId}
        onChange={(value) => pageLogic?.handleUserSelectedLaboratoryIdChange?.(value ?? '')}
        dropdownComponent="div"
        width={700}
      />
    </OrdersetListFiltersLayout>
  )
}
